import './FlyoutCard.css'
import PropTypes from "prop-types";

FlyoutCard.propTypes = {
    flyout: PropTypes.object.isRequired,
    onSelect: PropTypes.func
};

function formatDate(dateStr) {
    // format date as weekday dd-mmm-yyyy
    let date = new Date(dateStr);
    let weekday = date.toLocaleString('default', {weekday: 'short'});
    let day = date.getDate();
    let month = date.toLocaleString('default', {month: 'short'});
    let year = date.getFullYear();
    return `${weekday} ${day}-${month}-${year}`;
}

export default function FlyoutCard({flyout, onSelect}) {
    return (
        <div key={flyout.id} className="flyout-card" onClick={onSelect}>
            <img className="flyout-card-image" src={"/virtual-flyout/" + flyout.image}
                 alt={flyout.name}/>
            <div className="flyout-card-details">
                <h3 className="flyout-card-title">{flyout.name}</h3>
                <div className="flyout-card-highlights">
                    {flyout.highlights.map((highlight, index) =>
                        <span key={index}>{highlight}</span>
                    )}
                </div>
                <p className="flyout-card-dates">
                    {formatDate(flyout.days[0].date)}
                    {flyout.days.length > 1 && ` - ${formatDate(flyout.days[flyout.days.length - 1].date)}`}
                </p>
            </div>
        </div>
    );
}